import { Palette } from '@ppwr/poker'

import { Button, ButtonSimple } from './Button'
import { Center, Frame } from './Frame'
import { DSIcon, Icon } from './Icon'
import { Spacing } from './Spacing'
import { Text, TextScaled, Typography } from './Typography'

export const DS = {
  typography: Typography,
  palette: Palette,
  spacing: Spacing,
  Text,
  TextScaled,
  Frame,
  Center,
  Icon,
  Button,
  ButtonSimple
} as const

export type { DSIcon }
